module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_ii"
    }
  }), _c('strong', [_vm._v("Series Board")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_vm._v("James Bernauer")]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_vm._v("Drucilla Cornell")]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_vm._v("Thomas R. Flynn")]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_vm._v("Kevin Hart")]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_vm._v("Jean-Luc Marion")]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_vm._v("Adriaan Peperzak")]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_vm._v("Richard Kearney")]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_vm._v("Thomas Sheehan")]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_vm._v("Hent de Vries")]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_vm._v("Merold Westphal")]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_vm._v("Edith Wyschogrod")]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_vm._v("Michael Zimmerman")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d8b6fe9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/series.vue
// module id = 60
// module chunks = 0